(() => {
  'use strict';
  const dataNode = document.getElementById('FultonsNatuzziTableData');
  if (!dataNode) return;
  let groups;
  try { groups = JSON.parse(dataNode.textContent); } catch { return; }
  const param = 'natuzzi_finish';
  const make = (tag, cls, text) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text) node.textContent = text;
    return node;
  };
  const finishFor = (group, key) => group.finishes.find(finish => finish.key === key);
  const dimensionLabel = size => size.replace(/\s+h\s*(\d+(?:\.\d+)?)/i, ' × $1') + ' cm';

  function catalogue(card, group) {
    const image = card.querySelector('.living-test__image');
    const anchor = image?.closest('a');
    if (!image || !anchor) return;
    card.querySelectorAll('.fn-menu').forEach(node => node.remove());
    const labels = [...card.querySelectorAll('.fo-card-samples--cover-count')];
    const existing = labels[0];
    labels.slice(1).forEach(node => node.remove());
    if (card.dataset.natuzziFinishesReady && existing) return;
    const total = group.finishes.length;
    if (!total) return;
    const text = total + ' finish option' + (total === 1 ? '' : 's');
    const label = existing || make('span', 'fo-card-samples fo-card-samples--cover-count');
    if (label.textContent !== text) label.textContent = text;
    const productUrl = anchor.href;
    if (anchor.querySelector('h3,h2,.living-test__brand')) {
      const imageLink = make('a'); imageLink.href = productUrl;
      imageLink.setAttribute('aria-label', 'View ' + group.title);
      anchor.before(imageLink); imageLink.append(image);
    }
    if (!existing) {
      const priceLink = card.querySelector('.fultons-retail-price')?.closest('a');
      const detailsLink = card.querySelector('.living-test__details');
      if (priceLink) priceLink.after(label);
      else if (detailsLink) detailsLink.before(label);
      else card.append(label);
    }
    card.dataset.natuzziFinishesReady = 'true';
  }

  function picker(label, id, changed) {
    const field = make('div', 'fn-table-field');
    const labelNode = make('span', 'fn-table-label', label); labelNode.id = id + 'Label';
    const details = make('details', 'fce-picker');
    const summary = make('summary'); summary.id = id;
    const fixed = make('p', 'fn-table-fixed'); fixed.hidden = true;
    const list = make('div', 'fce-picker-list'); list.id = id + 'Options';
    list.setAttribute('role', 'group'); list.setAttribute('aria-label', label + ' options');
    summary.setAttribute('aria-controls', list.id);
    details.append(summary, list); field.append(labelNode, details, fixed);
    let entries = [], selected = '';
    const content = (node, item, arrow) => {
      node.replaceChildren();
      if (item.thumbnail) {
        const img = make('img'); img.src = item.thumbnail; img.alt = ''; img.width = 34; img.height = 34;
        img.loading = 'lazy'; node.append(img);
      }
      node.append(make('span', '', item.label));
      if (arrow) { const mark = make('span', 'fce-picker-arrow', '⌄'); mark.setAttribute('aria-hidden', 'true'); node.append(mark); }
    };
    function update(items, value) {
      entries = items; selected = value;
      const current = items.find(item => item.value === value) || items[0];
      if (!current) return;
      const single = items.length === 1;
      details.hidden = single;
      details.style.display = single ? 'none' : '';
      fixed.hidden = !single;
      fixed.style.display = single ? 'flex' : 'none';
      if (single) { details.open = false; content(fixed, current, false); }
      content(summary, current, true);
      summary.setAttribute('aria-label', label + ': ' + current.label);
      list.replaceChildren();
      items.forEach(item => {
        const button = make('button'); button.type = 'button';
        button.setAttribute('aria-label', item.label);
        button.dataset.value = item.value; button.setAttribute('aria-pressed', String(item.value === selected));
        content(button, item, false);
        button.addEventListener('click', event => {
          event.preventDefault(); event.stopPropagation();
          changed(item.value); details.open = false; summary.focus({preventScroll: true});
        });
        list.append(button);
      });
    }
    details.addEventListener('keydown', event => {
      if (event.key === 'Escape') { details.open = false; summary.focus(); event.preventDefault(); return; }
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault(); details.open = true;
      const buttons = [...list.querySelectorAll('button')];
      const i = buttons.indexOf(document.activeElement);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : i < 0 ? Math.max(0, entries.findIndex(item => item.value === selected)) : (i + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
      buttons[next]?.focus();
    });
    details.addEventListener('focusout', event => {
      if (event.relatedTarget && !details.contains(event.relatedTarget)) details.open = false;
    });
    document.addEventListener('pointerdown', event => {
      if (details.open && !details.contains(event.target)) details.open = false;
    });
    return {field, update};
  }

  function product(group, id) {
    const root = document.querySelector('#MainContent .catalogue-proof:not([hidden]),#MainContent .pdp-refined:not([hidden])');
    const legacy = root?.querySelector('#FultonsOtherExactChoice');
    const box = legacy?.closest('.other-exact');
    const source = window.FultonsOtherExactOptions?.[id];
    if (!legacy || !box || !source || box.dataset.natuzziReady) return;
    const choices = source.options.map((option, index) => {
      const reference = group.options.find(item => item.label === option.label);
      return reference ? {...reference, index} : null;
    });
    if (choices.some(choice => !choice)) return;
    let current = choices[legacy.selectedIndex] || choices[0];
    const selectionKey = 'fultons:natuzzi-table:' + id;
    const parameters = new URL(location.href).searchParams;
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(selectionKey)); } catch {}
    const requested = parameters.get(param) || saved?.finish;
    const requestedSize = parameters.get('natuzzi_size') || saved?.size || current.size;
    current = choices.find(choice => choice.finish === requested && choice.size === requestedSize) || choices.find(choice => choice.finish === requested) || current;
    const controls = make('div', 'fn-table-controls');
    const selectChoice = (choice, remember = true) => {
      if (!choice) return;
      current = choice; legacy.value = String(choice.index);
      legacy.dispatchEvent(new Event('change', {bubbles: true}));
      sync();
      if (remember) {
        try { sessionStorage.setItem(selectionKey, JSON.stringify({finish: current.finish, size: current.size})); } catch {}
        const url = new URL(location.href);
        url.searchParams.set(param, current.finish);
        url.searchParams.set('natuzzi_size', current.size);
        history.replaceState(history.state, '', url);
      }
    };
    const sizes = picker('1. Size', 'NatuzziTableSize', value => selectChoice(choices.find(choice => choice.size === value && choice.finish === current.finish) || choices.find(choice => choice.size === value)));
    const finishes = picker('2. Finish', 'NatuzziTableFinish', value => selectChoice(choices.find(choice => choice.finish === value && choice.size === current.size)));
    function sync() {
      sizes.update([...new Set(choices.map(choice => choice.size))].map(size => ({value: size, label: dimensionLabel(size)})), current.size);
      const available = new Set(choices.filter(choice => choice.size === current.size).map(choice => choice.finish));
      finishes.update(group.finishes.filter(finish => available.has(finish.key)).map(finish => ({value: finish.key, label: finish.label, thumbnail: finish.thumbnail})), current.finish);
      box.dataset.selectedFinish = current.finish; box.dataset.selectedSize = current.size;
    }
    controls.append(sizes.field, finishes.field);
    legacy._pictureCleanup?.();
    const originalLabel = box.querySelector('label[for="FultonsOtherExactChoice"]');
    if (originalLabel) { originalLabel.hidden = true; originalLabel.htmlFor = 'FultonsNatuzziExactChoice'; }
    legacy.id = 'FultonsNatuzziExactChoice'; legacy.hidden = true;
    box.querySelectorAll('.ffp-view').forEach(node => node.remove());
    legacy.after(controls);
    box.classList.add('fn-table-ready'); box.dataset.natuzziReady = 'true';
    selectChoice(current, false);
  }

  let pending = false;
  const render = () => {
    document.querySelectorAll('.living-test__card[data-product-id]').forEach(card => {
      const group = groups[card.dataset.productId]; if (group) catalogue(card, group);
    });
    const id = new URL(location.href).searchParams.get('draft_product') || String(window.FultonsPriceTrial?.productId || '');
    if (groups[id]) product(groups[id], id);
  };
  const schedule = () => { if (pending) return; pending = true; requestAnimationFrame(() => { pending = false; render(); }); };
  new MutationObserver(schedule).observe(document.getElementById('MainContent') || document.documentElement, {childList: true, subtree: true});
  document.addEventListener('fultons:catalogue-updated', schedule);
  window.addEventListener('pageshow', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once: true}); else schedule();
})();

(() => {
  const main = document.getElementById('MainContent');
  if (!main) return;
  const states = new WeakMap();
  let pending = false;
  function refresh() {
    pending = false;
    main.querySelectorAll('select').forEach(select => {
      const label = [...(select.labels || [])].map(node => node.textContent).join(' ');
      const description = [select.id, select.getAttribute('aria-label'), label].join(' ');
      if (!/model|size|configuration|version|FultonsOtherExactChoice|FultonsCattelanOption/i.test(description)) return;
      const options = [...select.options].filter(option => !option.disabled && option.value !== '');
      let state = states.get(select);
      if (options.length !== 1) {
        if (state) {
          state.nodes.forEach(({node, style}) => { if (style === null) node.removeAttribute('style'); else node.setAttribute('style', style); });
          state.fixed.remove(); states.delete(select);
        }
        return;
      }
      const sibling = select.nextElementSibling?.classList.contains('fultons-single-model') ? select.nextElementSibling.nextElementSibling : select.nextElementSibling;
      const visual = sibling?.matches('details.fce-picker,details.fultons-visual-choice,details.pcf-picker,.fcs-picker') ? sibling : select.parentElement.querySelector(':scope > .fuc-picker');
      if (state && state.visual !== visual) {
        state.nodes.forEach(({node, style}) => { if (style === null) node.removeAttribute('style'); else node.setAttribute('style', style); });
        state.fixed.remove(); states.delete(select); state = null;
      }
      if (!state) {
        const fixed = document.createElement('p'); fixed.className = 'fultons-single-model';
        fixed.style.cssText = 'display:flex;align-items:center;gap:12px;margin:8px 0 20px;font:inherit;line-height:1.5';
        const nodes = [select, visual].filter(Boolean).map(node => ({node, style:node.getAttribute('style')}));
        nodes.forEach(({node}) => node.style.setProperty('display', 'none', 'important'));
        (visual || select).after(fixed);
        state = {fixed, nodes, visual, value:null}; states.set(select, state);
      }
      const text = options[0].textContent.trim();
      if (state.value !== text) {
        state.fixed.textContent = text; state.value = text;
      }
    });
  }
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(refresh); } };
  new MutationObserver(schedule).observe(main, {childList:true, subtree:true});
  main.addEventListener('change', schedule);
  document.addEventListener('fultons:catalogue-updated', schedule);
  schedule();
})();
